import type { MapMarkerProps } from "./map-marker.type";

import { AdvancedMarker } from "@vis.gl/react-google-maps";

import MapMarkerIcon from "../map-marker-icon";

const MapMarker = ({
  marker,
  onMarkerClick,
  onAdvancedMarkerRender,
}: MapMarkerProps) => {
  // Keep `onClick=undefined` when `onMarkerClick` is not defined to make
  // sure marker is not clickable and respect accessibility purposes.
  const onClick = onMarkerClick ? () => onMarkerClick(marker) : undefined;

  return (
    <AdvancedMarker
      ref={(advancedMarker) => {
        onAdvancedMarkerRender?.({ advancedMarker, marker });
      }}
      title={marker.name}
      position={marker.position}
      onClick={onClick}
    >
      {marker.type === "default" ? undefined : (
        <MapMarkerIcon marker={marker} />
      )}
    </AdvancedMarker>
  );
};

export default MapMarker;
